
export default {
	SCREEN_SETTINGS: 'ScreenSettings',
	PANEL: 'panel',
};
